import type { FC } from 'react';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import { html } from '../../utils/dom';
import { replaceEmojis } from '../../utils/emoji';

interface Props {
  subject: string;
  className?: string;
}

export const TopicSubject: FC<Props> = memo(function TopicSubject({ subject, className }) {
  return (
    <span className={twMerge('TopicSubject', className)}>
      {html(replaceEmojis(subject, '!inline !text-[length:inherit]'))}
    </span>
  );
});
